import { PurchaseType } from '@occc-app/routes/Transactions/TransactionView/types';
import { Activate_Transaction_Status } from '@occc/graphql';

// List of Order Ahead provider/vendor names which can be used in transaction.vendorName field to identify order ahead transactions.
export const orderAheadVendorNames = ['olo', 'lula', 'altaine', 'vroom'];

export const ORDER_AHEAD_RECEIPT_MESSAGE = 'Please see the order ahead receipt';

export const purchaseTypeLabelMap: Record<PurchaseType, string> = {
  'order-ahead': 'Online Order',
};

export const activateTransactionStatusLabelMap: Record<Activate_Transaction_Status, string> = {
  [Activate_Transaction_Status.Cancelled]: 'Cancelled',
  [Activate_Transaction_Status.Completed]: 'Completed',
  [Activate_Transaction_Status.Migrated]: 'Migrated',
  [Activate_Transaction_Status.Redeemed]: 'Redeemed',
};
